/* ===========================================================================
   HH Afterpay on-site messaging — custom, no app, no Afterpay JS.

   WHY CUSTOM: the official "Afterpay On-Site Messaging" app is 3.0 stars with
   63% one-star reviews; the two most-reported failures are (a) the price not
   updating with variant/tier selectors and (b) the app block rendering 0px.
   Both would break this store, whose one-time price moves with the 4/6/10/20
   box ladder. So this hand-rolls it: official artwork + our own maths.

   THE ONE RULE THAT MATTERS: Afterpay is only offered at checkout on the
   ONE-TIME path. BNPL cannot back a recurring charge, so it never appears for
   Set & Forget. Showing instalments on a subscription would be misleading and
   would breach Afterpay's merchant terms. Every placement below is therefore
   either scoped to the one-time option or carries the "one-time orders"
   qualifier, and the cart placements go quiet when a subscription line is
   present.

   ARTWORK: the official Afterpay badge, fetched 22 Sep 2026 from
   https://static.afterpay.com/icon/afterpay-icon-colour-border.svg — the exact
   asset URL Afterpay's own Shopify script builds (static.afterpay.com/icon/
   afterpay-{format}-{theme}-{background}.svg). Inlined verbatim, unmodified,
   so there is no third-party request and no hotlink to break. Do not redraw it.

   LIMITS: AP_MIN / AP_MAX below are DEFAULTS, not confirmed merchant values —
   they could not be read without the Afterpay merchant portal login. Every
   order this store takes ($89–$560) sits well inside any plausible AU range,
   but confirm them in the portal and correct them here.
   =========================================================================== */
(function () {
  'use strict';

  /* ---- config ------------------------------------------------------------ */
  var AP_MIN = 1.00;      /* AUD — confirm in the Afterpay merchant portal */
  var AP_MAX = 2000.00;   /* AUD — confirm in the Afterpay merchant portal */
  var AP_TERMS = 'https://www.afterpay.com/en-AU/terms-of-service';

  /* Official badge, 38x24, unmodified. */
  var BADGE = '<svg class="hh-ap-badge" height="24" viewBox="0 0 38 24" width="38" role="img" aria-label="Afterpay" xmlns="http://www.w3.org/2000/svg">'
    + '<path d="m35 0h-32c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3v-18c0-1.7-1.4-3-3-3z" fill="#b2fce4"/>'
    + '<path d="m27.4 6.8-2.7-1.6-2.7-1.6c-1.8-1-4.1.3-4.1 2.4v.4c0 .2.1.4.3.5l1.3.7c.4.2.8-.1.8-.5v-.8c0-.4.4-.7.8-.5l2.5 1.4 2.4 1.5c.4.2.4.7 0 .9l-2.5 1.4-2.5 1.6c-.4.2-.8-.1-.8-.5v-.4c0-2.1-2.3-3.4-4.1-2.4l-2.7 1.6-2.7 1.6c-1.8 1-1.8 3.7 0 4.7l2.7 1.6 2.7 1.6c1.8 1 4.1-.3 4.1-2.4v-.4c0-.2-.1-.4-.3-.5l-1.3-.7c-.4-.2-.8.1-.8.5v.8c0 .4-.4.7-.8.5l-2.5-1.4-2.5-1.5c-.4-.2-.4-.7 0-.9l2.5-1.4 2.5-1.4c.4-.2.8.1.8.5v.4c0 2.1 2.3 3.4 4.1 2.4l2.7-1.6 2.7-1.6c1.9-1.2 1.9-3.8.1-4.9z"/></svg>';

  var INFO = '<a class="hh-ap-info" href="' + AP_TERMS + '" target="_blank" rel="noopener"'
    + ' aria-label="Afterpay payment terms (opens in a new tab)">&#9432;</a>';

  var css = ''
    + '.hh-ap{display:flex;align-items:center;gap:6px;flex-wrap:wrap;'
    + 'font-size:11.5px;line-height:1.35;font-weight:600;color:#5A6786}'
    + '.hh-ap .hh-ap-badge{height:16px;width:auto;flex:none;border-radius:3px}'
    + '.hh-ap b{font-weight:800;color:#16234A;font-variant-numeric:tabular-nums}'
    + '.hh-ap-info{color:#7A85A3;text-decoration:none;font-size:12px;line-height:1;flex:none}'
    + '.hh-ap-info:hover{color:#1E326C}'
    /* Inside the one-time buy-box card. The 13px side padding lines the badge up
       with the radio column above it (.hh-t-opt is padded 9px 13px), instead of
       letting it touch the card border; 11px at the bottom stops it sitting on
       the border too. No top margin - .hh-t-opt already contributes 9px, which
       is the whole gap we want under "One-time Purchase". */
    + '.hh-t-optbox[data-mode="one"] .hh-ap{margin:0;padding:0 13px 11px}'
    /* cart drawer + cart page line */
    + '.hh-ap--cart{justify-content:center;text-align:center;margin:8px 0 0}'
    + '.hh-ap--cart.is-muted{opacity:.55}'
    + '.hh-ap-note{font-size:10.5px;font-weight:700;color:#7A85A3}'
    /* payment-icon rows: match the neighbouring 38x24 badges */
    + '.hh-footer__pay .hh-ap-badge{width:40px;height:auto;border-radius:4px}'
    + '.hhcf-pay .hh-ap-badge{height:22px;width:auto;border-radius:3px}'
    + '.cart-drawer .hhcf-pay .hh-ap-badge{height:20px}'
    + '@media (max-width:359px){.hh-ap{font-size:11px}}';

  var st = document.createElement('style');
  st.id = 'hh-afterpay-css';
  st.textContent = css;
  document.head.appendChild(st);

  function money(n) { return '$' + n.toFixed(2); }
  function inRange(total) { return total >= AP_MIN && total <= AP_MAX; }
  /* Afterpay quotes the instalment as total / 4 to 2dp. */
  function perInstalment(total) { return Math.round((total / 4) * 100) / 100; }

  /* The ⓘ sits inside the one-time card, and that card selects itself on click —
     which re-renders the card, tears the anchor out of the DOM between mousedown
     and mouseup, and swallows the navigation. That was the "click it three times
     before it opens" bug. Keeping the click off the card fixes it in one tap,
     and an info link shouldn't be changing the purchase option anyway. */
  function armInfo(scope) {
    var a = scope && scope.querySelector('.hh-ap-info');
    if (!a || a.hhArmed) return;
    a.hhArmed = 1;
    a.addEventListener('click', function (e) { e.stopPropagation(); });
  }

  function msgHTML(total, note) {
    return BADGE
      + '<span>or 4 payments of <b>' + money(perInstalment(total)) + '</b> with Afterpay</span>'
      + (note ? '<span class="hh-ap-note">' + note + '</span>' : '')
      + INFO;
  }

  /* =========================================================================
     1. PDP — inside the One-time Purchase card only.

     The buy-box engine (hh-sub-tiers.js) re-renders this card wholesale on any
     tier/plan change, so we observe and re-apply rather than injecting once.
     The price is read back out of the rendered card, which means it can never
     disagree with what the customer is being charged: .hh-t-opttot holds
     "<s>$349.70</s>$243.50" and the payable figure is the trailing text node.
     ========================================================================= */
  function pdp() {
    var root = document.querySelector('[data-hh-tiers]');
    if (!root) return;

    function paint() {
      var one = root.querySelector('.hh-t-optbox[data-mode="one"]');
      if (!one) return;

      /* Belt and braces: if this ever matched the sub card, bail out. */
      if (one.getAttribute('data-mode') !== 'one') return;

      var tot = one.querySelector('.hh-t-opttot');
      var last = tot && tot.lastChild;
      var txt = last && last.nodeType === 3 ? last.nodeValue : (tot ? tot.textContent : '');
      var m = String(txt).match(/([\d,]+\.\d{2})\s*$/);
      var price = m ? parseFloat(m[1].replace(/,/g, '')) : NaN;

      var el = one.querySelector('.hh-ap');
      if (!price || !inRange(price)) { if (el) el.remove(); return; }

      if (!el) {
        el = document.createElement('div');
        el.className = 'hh-ap';
        var opt = one.querySelector('.hh-t-opt');
        (opt || one).insertAdjacentElement('afterend', el);
      }
      /* Compare a signature, not innerHTML: the browser serialises &#9432; back as
         the literal character, so an innerHTML comparison never matches and the
         node would be rebuilt on every single repaint - which can tear the info
         link out from under a click. */
      var sig = 'one:' + price;
      if (el.getAttribute('data-sig') !== sig) {
        el.innerHTML = msgHTML(price, '');
        el.setAttribute('data-sig', sig);
        armInfo(el);
      }
    }

    /* Never let one of these land in the subscription card. */
    function scrub() {
      var subs = root.querySelectorAll('.hh-t-optbox[data-mode="sub"] .hh-ap');
      Array.prototype.forEach.call(subs, function (n) { n.remove(); });
    }

    var busy = false, queued = false;
    function run() {
      if (busy) return;
      busy = true;
      try { paint(); scrub(); } finally { busy = false; }
    }

    /* setTimeout, not requestAnimationFrame: rAF is throttled to a standstill in
       a background or hidden tab, which leaves the message missing after a tier
       change until the tab is focused again. Nothing here animates, so a macro
       task is both sufficient and more reliable. */
    function schedule() {
      if (busy || queued) return;
      queued = true;
      setTimeout(function () { queued = false; run(); }, 0);
    }

    new MutationObserver(schedule)
      .observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    root.addEventListener('change', schedule);
    run();
  }

  /* =========================================================================
     2 + 3. Cart drawer and cart page.

     Both read /cart.js rather than scraping a subtotal, which gives the exact
     cents AND the subscription flag in one call. A line with a selling plan
     carries selling_plan_allocation, and any such line means checkout will not
     offer Afterpay — so the message is muted and re-worded rather than removed,
     which explains to the shopper why it is unavailable instead of silently
     vanishing.
     ========================================================================= */
  var cartState = null;

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cartState = {
          total: (c.total_price || 0) / 100,
          hasSub: (c.items || []).some(function (i) {
            return !!(i.selling_plan_allocation || i.selling_plan_allocation_id);
          }),
          count: c.item_count || 0
        };
        return cartState;
      })
      .catch(function () { return null; });
  }

  /* Set while we are writing, so our own DOM changes don't re-trigger the
     observer that called us. Cleared on the next tick, once they have flushed. */
  var painting = false;

  function paintCartAreas() {
    if (!cartState || painting) return;
    painting = true;
    try { paintCartAreasInner(); }
    finally { setTimeout(function () { painting = false; }, 0); }
  }

  function paintCartAreasInner() {

    /* --- the icon row in the drawer and, if present, on the cart page --- */
    Array.prototype.forEach.call(document.querySelectorAll('.hhcf-pay'), function (row) {
      if (row.querySelector('.hh-ap-badge')) return;
      var span = document.createElement('span');
      span.style.display = 'inline-flex';
      span.innerHTML = BADGE;
      row.appendChild(span);
    });

    /* --- the message above the icon row --- */
    var hosts = document.querySelectorAll('.cart__ctas, .cart__blocks .cart__ctas');
    Array.prototype.forEach.call(hosts, function (host) {
      var el = host.querySelector('.hh-ap--cart');
      var show = cartState.count > 0 && inRange(cartState.total);
      if (!show) { if (el) el.remove(); return; }

      if (!el) {
        el = document.createElement('div');
        el.className = 'hh-ap hh-ap--cart';
        var pay = host.querySelector('.hhcf-pay');
        if (pay) host.insertBefore(el, pay); else host.appendChild(el);
      }
      el.classList.toggle('is-muted', cartState.hasSub);

      var sig = (cartState.hasSub ? 'sub:' : 'one:') + cartState.total;
      if (el.getAttribute('data-sig') !== sig) {
        el.innerHTML = cartState.hasSub
          ? BADGE + '<span>Afterpay isn’t available on subscription orders</span>' + INFO
          : msgHTML(cartState.total, '— available on one-time orders');
        el.setAttribute('data-sig', sig);
        armInfo(el);
      }
    });
  }

  var pending = null;
  function refreshCart() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      readCart().then(function () { paintCartAreas(); });
    }, 180);
  }

  /* The drawer is re-rendered by Dawn's renderContents() after every add, and by
     our own bundle/buy-box code, so that re-render is the signal we watch.

     We deliberately do NOT wrap window.fetch to catch /cart/add.js. An earlier
     revision did, and it broke the whole storefront: this file is strict mode, a
     bare fetch(...) call therefore passes this === undefined, and fetch with a
     non-Window `this` throws "Illegal invocation" — so every fetch on the page
     started failing, Dawn's cart included. Watching the drawer is enough, and
     patching a global on a store with this many apps is not worth the risk. */
  function watchCart() {
    if (!document.querySelector('cart-drawer, cart-notification, .cart__ctas')) return;
    readCart().then(function () { paintCartAreas(); });

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        if (!painting) refreshCart();
      }).observe(drawer, { childList: true, subtree: true });
    }

    ['cart:refresh', 'cart:updated'].forEach(function (ev) {
      document.addEventListener(ev, refreshCart);
      window.addEventListener(ev, refreshCart);
    });
  }

  function boot() { pdp(); watchCart(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
